/* eslint-disable indent */
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Modal } from 'appkit-react';
import { useReactiveVar } from '@apollo/client';

import { selectValueVar } from '../../Apollo/config';
import UploadTabOne from './UploadTabOne';
import UploadTabTwo from './UploadTabTwo';
import UploadTabThree from './UploadTabThree';
import closeIcons from '../../assets/images/close-24px.svg';
import './uploadreport.scss';

const UploadReport = () => {
    const [visible, setVisible] = useState(true);
    const [tab, setTab] = useState('first');
    const { displayName: selectValue } = useReactiveVar(selectValueVar);
    const history = useHistory();

    // eslint-disable-next-line no-nested-ternary
    const titleTxt = tab === 'first'
        ? 'Confirm Report / Schedule'
        : tab === 'second'
            ? 'Prepare your files'
            : 'Select your files';

    /* function to handle cancellation of regulation report upload */
    const onHandleCancel = () => {
        setVisible(false);
        let pathName;
        if (selectValue === 'FR Y-7Q') {
            pathName = '/fry7q';
        } else if (selectValue === 'FR Y-9C') {
            pathName = '/fry9c';
        } else if (selectValue === 'Metro2') {
            pathName = '/metro2';
        } else if (selectValue === 'FFIEC009') {
            pathName = '/FFIEC009';
        } else if (selectValue === 'FFIEC 031') {
            pathName = '/ffiec031';
        } else if (selectValue === 'FFIEC 041') {
            pathName = '/ffiec041';
        } else if (selectValue === 'FR 2052a') {
            pathName = '/fr2052a';
        } else {
            pathName = '';
        }
        history.push(
            {
                pathname: pathName,
                state: {
                    regulation: selectValue,
                },
            },
        );
        setTab('first');
    };

    return (
        <Modal
            className="baseline-modal-showcase true-comply-upload__report__modal"
            visible={visible}
            data-testid="model"
        >
            <div className="true-comply-upload__report__headsection">
                <div className="true-comply-upload__report__headsection-wrapper">
                    <div className="true-comply-upload__report__headsection-wrapper-left">
                        <div className="true-comply-upload__report__headsection-wrapper-left-close">
                            <img
                                src={closeIcons}
                                alt="modal close"
                                onClick={onHandleCancel}
                                aria-hidden="true"
                                data-testid="btn-cancel"
                            />
                        </div>
                        <div className="true-comply-upload__report__headsection-wrapper-left-text">
                            <p className="true-comply-upload__report__headsection-wrapper-left-text-subtitle">
                                Upload reports
                            </p>
                            <p className="true-comply-upload__report__headsection-wrapper-left-text-title">
                                {titleTxt}
                            </p>
                        </div>
                    </div>
                    <div className="true-comply-upload__report__headsection-wrapper-right">
                        <div
                            className={`true-comply-upload__report__headsection-wrapper-right-numbers ${tab === 'first' ? 'in_progress' : 'active'
                                }`}
                        >
                            1
                        </div>
                        <div className="hr-dashline" />
                        <div
                            className={`true-comply-upload__report__headsection-wrapper-right-numbers ${tab === 'third' && 'active'
                                } ${tab === 'second' ? 'in_progress' : ''}`}
                        >
                            2
                        </div>
                        <div className="hr-dashline" />
                        <div
                            className={`true-comply-upload__report__headsection-wrapper-right-numbers ${tab === 'third' && 'in_progress'
                                }`}
                        >
                            3
                        </div>
                    </div>
                </div>
            </div>
            {tab === 'first' ? (
                <UploadTabOne setTab={setTab} selectValue={selectValue} />
            ) : (
                <div />
            )}
            {tab === 'second' ? (
                <UploadTabTwo setTab={setTab} selectValue={selectValue} />
            ) : (
                <div />
            )}
            {tab === 'third' ? (
                <UploadTabThree setTab={setTab} selectValue={selectValue} />
            ) : (
                <div />
            )}
        </Modal>
    );
};

export default UploadReport;
